/**
 * Created by jv on 16/01/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");
const Ticket = require("Sources/models/ticket");
const Error = require("Sources/models/error");

var ticketService = {};

(function(TicketService)
{
  function dataToError(data, callback)
  {
    if(utils.isFunction(callback))
    {
      if(data.hasOwnProperty("exception"))
      {
        callback(new Error(data.exception));
      }
      else
      {
        callback(new Error({
          code: null,
          message: null
        }));
      }
    }
  }

  TicketService.validateTicket = function(code, type, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("validate_ticket"),
      cache: false,
      dataType: "json",
      data: {
        code: code,
        type: type
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  TicketService.getTicketInfo = function(code, type, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_ticket_info"),
      cache: false,
      dataType: "json",
      data: {
        code: code,
        type: type
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new Ticket(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  TicketService.getValidateTicketSessionData = function(successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_validate_ticket_session_data"),
      cache: false,
      dataType: "json"
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result.type, data.result.result.code);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

}(ticketService));

module.exports = ticketService;



// WEBPACK FOOTER //
// ./app/js/services/fundels/ticket-services.js